module.exports = __webpack_public_path__ + "static/media/ChocoChip Cookies 200g.c1624249.jpg";